import { render, staticRenderFns } from "./singlePage.vue?vue&type=template&id=cc152d9e&scoped=true"
import script from "./singlePage.vue?vue&type=script&lang=js"
export * from "./singlePage.vue?vue&type=script&lang=js"
import style0 from "./singlePage.vue?vue&type=style&index=0&id=cc152d9e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc152d9e",
  null
  
)

export default component.exports